import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_COLIS_LOGISTIQUE_REQUEST: 'FETCH_COLIS_LOGISTIQUE_REQUEST',
    FETCH_COLIS_LOGISTIQUE_SUCCESS: 'FETCH_COLIS_LOGISTIQUE_SUCCESS',
    FETCH_COLIS_LOGISTIQUE_FAILURE: 'FETCH_COLIS_LOGISTIQUE_FAILURE',

    CLEAR_COLIS_LOGISTIQUE: 'CLEAR_COLIS_LOGISTIQUE'
};

/**
 * FETCH_COLIS_LOGISTIQUE
 * ActionCreator pour la récupération des Colis d'un pièce gestion
 */
const fetchColisLogistiqueRequest = () => ({ type: Actions.FETCH_COLIS_LOGISTIQUE_REQUEST });
const fetchColisLogistiqueSuccess = colisLogistiques => ({ type: Actions.FETCH_COLIS_LOGISTIQUE_SUCCESS, colisLogistiques });
const fetchColisLogistiqueFailure = error => ({ type: Actions.FETCH_COLIS_LOGISTIQUE_FAILURE, error });

export const fetchColisLogistique = (numeroPiece) => async (dispatch) => {
    dispatch(fetchColisLogistiqueRequest());

    try {
        let response = await axios.get('api/colis-logistique', {
            params: {
                numeroPiece: numeroPiece
            }
        });

        dispatch(fetchColisLogistiqueSuccess(response.data));
    } catch (error) {
        dispatch(fetchColisLogistiqueFailure(error));
    }
};

/**
 * ActionCreator pour CLEAR_COLIS_LOGISTIQUE
 */
export const clearColisLogistique = () => ({ type: Actions.CLEAR_COLIS_LOGISTIQUE });